import bugsnagClient from "./bugsnag";
import "./axios";
import "./lodash";
import i18n from "./vue-i18n";

export { i18n, bugsnagClient };



// WEBPACK FOOTER //
// ./resources/js/plugins/index.js